import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '@app/_services/auth/auth.service';
import { UserAuthDto } from '@app/shared/model/user.model';
import { APP_NAME } from '@app/shared/utilities/app-info';

@Component({
  selector: 'app-auth-dashboard',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './auth-dashboard.component.html',
  styleUrl: './auth-dashboard.component.scss'
})
export class AuthDashboardComponent implements OnInit {
  readonly appName = APP_NAME;
  currentUser: UserAuthDto | null = null;

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.currentUser = this.authService.getCurrentUserValue();
  }

  get displayName(): string {
    return this.currentUser?.fullName || this.currentUser?.userName || '';
  }
}
